var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhMediaPackage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "System/Line/Package"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80764 3.96523L2.866 4.90338C2.84265 4.9064 2.81943 4.9102 2.79641 4.91476C2.71163 4.93142 2.63079 4.95825 2.55535 4.99383C2.39585 5.0688 2.25628 5.1845 2.15591 5.33484C2.05075 5.49165 1.99368 5.67806 2.00056 5.87305L2.00056 17.1874C1.99928 17.2391 2.00251 17.2907 2.01008 17.3415C2.03055 17.4815 2.08333 17.6117 2.16104 17.7252C2.26262 17.8735 2.40681 17.9932 2.57719 18.0688L8.52244 20.8849C8.71163 20.9825 8.93536 21.0231 9.16429 20.987L21.1639 19.0923C21.1755 19.0905 21.187 19.0885 21.1985 19.0863C21.6556 18.999 21.9998 18.6164 21.9998 18.1576L21.9998 6.80751C22.0032 6.63095 21.9542 6.45705 21.86 6.30617C21.7771 6.17349 21.6592 6.0586 21.5111 5.97536C21.486 5.96116 21.4601 5.94797 21.4336 5.93586L15.4472 3.10022C15.2414 3.00271 15.017 2.97878 14.8074 3.0179L8.8658 3.95605C8.84631 3.95857 8.82691 3.96163 8.80764 3.96523ZM12.1984 5.35064L14.8442 4.93288L17.8027 6.33427L15.1569 6.75203L12.1984 5.35064ZM8.84445 5.88021L11.803 7.2816L9.15716 7.69936L6.19865 6.29796L8.84445 5.88021ZM4.00049 16.6247L8.00034 18.5193L8.00034 9.26968L4.00048 7.37503L4.00049 16.6247ZM14.0001 8.85547L14.0001 11.5263C14.0001 12.0495 14.4478 12.4736 15.0001 12.4736C15.5524 12.4736 16.0001 12.0495 16.0001 11.5263V8.5397L19.9999 7.90815L19.9999 17.3553L10.0003 18.9342L10.0003 9.48703L14.0001 8.85547Z",
    fill: "#00182F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhMediaPackage);
export default __webpack_public_path__ + "static/media/fmh-media-package.6a9f16735c181158c4770ab66c2a9f11.svg";
export { ForwardRef as ReactComponent };